import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalVisibilidadeAceitar = ({
    processo,
    laudo,
    isOpen,
    setIsOpen,
    aoSalvar
}) => {
    const [isLoading, setisLoading] = useState(false);
    const [loadAcao, setLoadAcao] = useState(null);
    const [observacao, setObservacao] = useState("");

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const onAfterOpen = () => { };
    const closeModal = () => { 
        setObservacao("");
        setisLoading(false);
        setIsOpen(false); 
    }

    const getLoadAcao = async (idTarefa) => {
        setisLoading(true);
        let list = null;
        try {
            const response = await api.get(`Visibilidade/tarefa/load/acao/${idTarefa}`);
            list = response.data.data;
            setLoadAcao(list);
        } catch (err) {
            console.error(err);
        } finally {
            setisLoading(false);
            return list;
        }
    }

    const onClickAction = (idTarefa, tipoAcao) => {
        Swal.fire({
            html: `Deseja Realizar essa Ação?`,
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            setisLoading(true);
            if (result.isConfirmed) {
                Swal.showLoading();
                try {
                    const headers = {
                        'Content-Type': 'application/json'
                    };

                    const dados = {
                        idTipoAcao: tipoAcao,
                        observacao: observacao,
                    };
                    await api.post(`Visibilidade/tarefa/executa/aceitar/${idTarefa}`, dados, { headers });
                    setisLoading(false);

                    Swal.fire({
                        title: "Sucesso",
                        text: "Tarefa Executada com Sucesso!",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(async (result) => {;
                        setObservacao("");

                        setisLoading(false);
                        setIsOpen(false);
                        closeModal();

                        if (aoSalvar) {
                            aoSalvar(laudo.idProcesso, laudo.idTipoServico);
                        }
                    })

                } catch (err) {setisLoading(false);}
            } else {
                setisLoading(false);
            }
        });
    };

    useEffect(() => {
        if(isOpen) {
            getLoadAcao(processo.idTarefa);
        }
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Aceitar"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="28" height="28" className="me-2">
                                        <path fill={'#999'} d="M552 288c13.3 0 24 10.7 24 24l0 104c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 312c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-104c0-13.3 10.7-24 24-24zM416 32c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64L96 96c0-35.3 28.7-64 64-64l256 0zm-37.1 84.6c-10.7-7.8-25.7-5.4-33.5 5.3l-85.6 117.7-26.5-27.4c-9.2-9.5-24.4-9.8-33.9-.6-9.5 9.2-9.8 24.4-.6 33.9l46.4 48c4.9 5.1 11.8 7.8 18.9 7.3s13.6-4.1 17.8-9.8L384.2 150.1c7.8-10.7 5.4-25.7-5.3-33.5z"/></svg>                                    
                                    Aceitar - { loadAcao?.nomeEtapa } </p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                { isLoading ? 
                (
                <div className="text-center">
                    <div className="text-items-center">
                        <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                        <div className="mt-2">
                            <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                        </div>
                    </div>
                </div>
                ) : (
                    <>
                    <div className="row mb-2" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Processo</span><br/>{ loadAcao?.processo?.processoSigla || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Líder</span><br/>{ loadAcao?.processo?.liderProcesso || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br/>{ loadAcao?.processo?.cliente || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Segurado</span><br/>{ loadAcao?.processo?.segurado || "-" }</div>
                    </div>
                    <div className="row" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Disciplina</span><br/>{ laudo.disciplina }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Responsável</span><br/>{ loadAcao?.nomeUsuarioResponsavel || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Criação</span><br/>{ new Date(loadAcao?.dataCriacao).toLocaleDateString('pt-BR') }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Prazo</span><br/>{ new Date(loadAcao?.dataPrazo).toLocaleDateString('pt-BR') }</div>

                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <div className="row align-items-center justify-content-center w-100">
                        <div className="col text-center">
                            <DynamicTextareaOnChange 
                                placeholder={"Observações"} 
                                label={"Observações"} 
                                name={"observacao"}
                                valuetext={observacao}
                                onChange={(e) => setObservacao(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <Flex>
                        <Flex.Item>
                            <div className="row align-items-center justify-content-center">
                                <div className="col text-center">
                                    <input 
                                        className='default-button-red' 
                                        value={'Aceitar'} 
                                        type="button" 
                                        onClick={onClickAction.bind(this, loadAcao?.idTarefa, loadAcao?.idTipoServico)}/>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    </>
                )}
            </StyledForm>
        </Modal>
    );
};